module.exports = __webpack_public_path__ + "img/Fairplay_New_Logo_l.4d0bd8f.png";